export const appEndpoint = process.env.VUE_APP_ENDPOINT_URL;
export const apiEndpoint = process.env.VUE_APP_API_ENDPOINT_URL;
export const cookieEndpoint = process.env.VUE_APP_COOKIE_ENDPOINT_URL;

export const locales = [
  { code: 'en', title: 'English' },
];

export const langCodes = [
  'en',
];

export const adminRoleId = 'ADMIN';
export const developerRoleId = 'DEVELOPER';
export const translatorRoleId = 'TRANSLATOR';
export const imageEditorRoleId = 'IMAGEEDITOR';

export const roles = [
  { id: adminRoleId, text: 'Admin' },
  { id: developerRoleId, text: 'Developer' },
  { id: translatorRoleId, text: 'Translator' },
  { id: imageEditorRoleId, text: 'Image Editor' },
];

export const defaultTextColors = {
  black: {
    rgba: {
      r: '0',
      g: '0',
      b: '0',
      a: '1',
    },
  },
  white: {
    rgba: {
      r: '255',
      g: '255',
      b: '255',
      a: '1',
    },
  },
};

export const defaultBackgroundColor = {
  rgba: {
    r: '74',
    g: '144',
    b: '226',
    a: '1',
  },
};


export default {
  appEndpoint,
  apiEndpoint,
  cookieEndpoint,

  locales,
  langCodes,

  defaultTextColors,
  defaultBackgroundColor,

  roles,
  adminRoleId,
  translatorRoleId,
  developerRoleId,
  imageEditorRoleId,
};
